import { UserType } from '../../types/userTypes'
import { Cta } from './Cta'

const ConsumerConnectorBaseUrl = 'https://www.clipsal.com/clipsal-electrician-locator'

const getElectricianConsumerConnectorLink = (listUrl: string) => {
  return `${ConsumerConnectorBaseUrl}?referrer=${btoa(JSON.stringify({
    type: 'iconic configurator',
    listUrl,
    entryPoint: 'electrician',
  }))}`
}

const WholesalerLocatorLink = 'https://www.clipsal.com/clipsal-support/locate/locate-wholesaler'

export const CtasClipsal: { readonly [key in UserType]: readonly Readonly<Cta>[] } = {
  [UserType.Consumer]: [
    {
      label: 'Find an Electrician',
      analyticsLabel: 'Find an Electrician',
      url: getElectricianConsumerConnectorLink,
    },
    {
      label: 'Find where to buy',
      analyticsLabel: 'Find where to buy',
      url: WholesalerLocatorLink,
    },
    {
      label: 'Electrical Design Service and Showrooms',
      analyticsLabel: 'Electrical Design Service and Showrooms',
      url: 'https://www.clipsal.com/design',
    },
  ],
  [UserType.Electrician]: [
    // {
    //   label: 'Get a Quote from a Wholesaler',
    //   url: WholesalerConsumerConnectorLink,
    // },
    {
      label: 'Customer Support',
      analyticsLabel: 'Customer Support',
      url: 'https://www.clipsal.com/clipsal-support/contact-us',
      id: 'customer-support'
    },
  ],
}
